import { Heros } from "./interfaces/hero";

export const DEFAULDATA: Heros = {
  heros: [
    {
      id: "ac7df704-e793-3a3d-bcb3-1d1dd7b7cd7f",
      title: [
        {
          type: "alignCenter",
          children: [
            {
              type: "headingOne",
              children: [
                {
                  bold: true,
                  text: "Descubre la revolución de la comodidad",
                  fontSize: "",
                  lineHeight: "10px",
                  letterSpacing: "",
                  color: "#ffffff",
                },
              ],
            },
            {
              type: "paragraph",
              children: [
                {
                  bold: true,
                  fontSize: "",
                  lineHeight: "10px",
                  letterSpacing: "",
                  text: "",
                  color: "#ffffff",
                },
              ],
            },
            {
              type: "paragraph",
              children: [
                {
                  fontSize: "22px",
                  lineHeight: "10px",
                  letterSpacing: "",
                  text: "Eleva tu presencia con nuestra colección exclusiva. Desde la oficina hasta la noche,",
                  color: "#ffffff",
                },
              ],
            },
            {
              type: "paragraph",
              children: [
                {
                  fontSize: "22px",
                  lineHeight: "10px",
                  letterSpacing: "",
                  text: "nuestros productos te acompañarán con elegancia y confianza.",
                  color: "#ffffff",
                },
              ],
            },
            {
              type: "paragraph",
              children: [
                {
                  fontSize: "22px",
                  lineHeight: "10px",
                  letterSpacing: "",
                  text: "Descubre la moda que habla por ti.",
                  color: "#ffffff",
                },
              ],
            },
          ],
        },
      ],
      image: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/293d7c99-df5e-4908-8472-2c6f827a3718.jpg",
      },
      button: { name: "Mas Información", url: "#" },
      opacity: "1.3",
      alling: "CENTER",
    },
  ],
};
